export default __webpack_public_path__ + "static/media/JobThree1.cf22e331.JPG";